$(function(){
    Shadowbox.init({
        viewportPadding: 30
    });


    var $window = $(window);
    /* Navigation */

    var Navigation = {

        selectors: {
            linkActiveClass: 'active',
            mainNavLink : $('.js-nav-item'),
            destinationBlock : $('.js-section'),
        },

        init: function(){

            var self = this;
            this.selectors.mainNavLink.on('click', function(e) {
                e.preventDefault();
                var sectionId = $(this).data('scroll-nav'),
                    currentLink =  self.findCurrentLink(sectionId);

                Utils.scrollTo($('#' + sectionId).offset().top - Header.headerHeight, function(){
                    self.updateClass(currentLink)
                });
            });

            this.selectors.destinationBlock.each(function(){
                var section = $(this),
                    sectionId = section.attr('id'),

                    top = section.offset().top -5 ,
                    bottom = section.height() + top,
                    correspondingNavLink = self.findCurrentLink(sectionId);

                self.updatePosition(top, bottom, correspondingNavLink);

                $window.on('scroll', function(){
                    self.updatePosition(top, bottom, correspondingNavLink)
                })
            });
        },

        updatePosition: function(top, bottom, correspondingNavLink){
            if($window.scrollTop() + Header.headerHeight > top && $window.scrollTop() < bottom) {
                this.updateClass(correspondingNavLink);
            }
        },

        updateClass: function(currentLink){
            this.selectors.mainNavLink.removeClass(this.selectors.linkActiveClass);
            currentLink.addClass(this.selectors.linkActiveClass);
        },

        findCurrentLink: function(sectionId){
            return this.selectors.mainNavLink.filter(function(){return $(this).data('scroll-nav') == sectionId})
        }
    };

    /*Fixed header */

    var Header = {
        breakpoints: {
            noFixed: 850,
        },
        headerHeight: 0,
        contentStart: 0,

        selectors: {
            fixedHeader : $('.js-nav'),
            fixedHeaderClass : 'nav--fixed',

        },

        init: function(){
            this.contentStart = $('.js-content').offset().top;
            this.headerHeight = this.selectors.fixedHeader.outerHeight();
            var self = this;
            this.setHeaderPosition();

            $window.on('scroll', function(){
                self.setHeaderPosition()
            });
            $window.on('resize', function(){
                self.headerHeight = self.selectors.fixedHeader.outerHeight();
                self.setHeaderPosition()
            });
        },

        setHeaderPosition: function(){

            var wWidth = $window.width();
            if (wWidth < this.breakpoints.noFixed){
                this.selectors.fixedHeader.removeClass(this.selectors.fixedHeaderClass);
            } else {
                if($window.scrollTop() > this.contentStart - this.headerHeight) {
                    this.selectors.fixedHeader.addClass(this.selectors.fixedHeaderClass);
                } else {
                    this.selectors.fixedHeader.removeClass(this.selectors.fixedHeaderClass);
                }
                }
            }

    };

    var Utils = {

        filterItem: function(collection, dataAttr, dataAttrValue) {
            return collection.filter(function(){
                return $(this).data(dataAttr) == dataAttrValue
            })
        },

        scrollTo: function(destination, callback){
            $('html, body').animate({
                scrollTop: destination
            }, 1000, callback);
        }
    };


    Navigation.init();
    Header.init();
})